import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Offerings from '../components/Offerings';
import HowItWorks from '../components/HowItWorks';
import Solutions from '../components/Solutions';
import Features from '../components/Features';
import Comparison from '../components/Comparison';
import Projects from '../components/Projects';
import Testimonials from '../components/Testimonials';
import Faqs from '../components/Faqs';
import Footer from '../components/Footer';
import { contactInfo } from '../mock';

const LandingPage = () => {
  const [modal, setModal] = useState(null); // 'book' | 'quote' | null

  const scrollToContact = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const handleCall = () => {
    window.location.href = `tel:+${contactInfo.whatsapp}`;
  };

  const openWhatsApp = () => {
    const phone = contactInfo.whatsapp;
    const text = encodeURIComponent(contactInfo.whatsappMsg);
    const ua = navigator.userAgent || '';
    const isMobile = /Android|iPhone|iPad|iPod|Windows Phone|IEMobile|Opera Mini|Mobile/i.test(ua)
      || (typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width: 768px)').matches);
    // Mobile: wa.me opens the WhatsApp app directly
    // Desktop: web.whatsapp.com opens WhatsApp Web in a new tab
    const url = isMobile
      ? `https://wa.me/${phone}?text=${text}`
      : `https://web.whatsapp.com/send?phone=${phone}&text=${text}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="App">
      <Navbar onBookConsult={scrollToContact} />
      <Hero onBook={scrollToContact} onQuote={() => setModal('quote')} onCall={handleCall} />
      <Offerings />
      <HowItWorks />
      <Solutions onEnquire={scrollToContact} />
      <Features />
      <Comparison />
      <Projects />
      <Testimonials />
      <Faqs />
      <Footer />

      {/* Floating WhatsApp */}
      <button
        onClick={openWhatsApp}
        aria-label="Chat on WhatsApp"
        className="wa-float fixed bottom-6 right-6 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-xl hover:scale-105 transition-transform z-40"
      >
        <MessageCircle size={26} />
      </button>

      {/* Quote modal */}
      {modal && (
        <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4" onClick={() => setModal(null)}>
          <div className="bg-white rounded-xl p-8 max-w-md w-full relative" onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setModal(null)} className="absolute top-3 right-3 text-gray-500 hover:text-[#0B1430]">
              <X size={20} />
            </button>
            <h3 className="text-2xl font-bold text-[#0B1430] mb-2">Get a Quote</h3>
            <p className="text-gray-600 mb-5 text-sm">Tell us about your project. We’ll get back within 24 hours.</p>
            <form onSubmit={(e) => { e.preventDefault(); setModal(null); }} className="space-y-3">
              <input className="bl-input" placeholder="Full Name" required />
              <input className="bl-input" placeholder="Phone Number" required />
              <textarea className="bl-input" placeholder="Project details" rows={3} />
              <button type="submit" className="w-full px-5 py-3 rounded-md bg-[#D4A853] hover:bg-[#B8893A] text-[#0B1430] font-semibold transition-colors">Submit Request</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default LandingPage;
